<template>
  <div class="newProduct" id="newProduct">
    <my-header />

    <!-- 新品发布 -->
    <div class="pre">
      <div class="allTitle">
        <span>新品发布</span>
      </div>
    </div>

    <div class="img1">
      <img src="@/assets/29.jpg" />
    </div>

    <!-- 未来源于对探索的挚爱 -->
    <div class="future">
      <img src="@/assets/future.jpg" />
    </div>

    <div class="pre">
      <div class="news">
        <p class="p1">全新独有时尚配色设计</p>
        <p class="p2">
          一次创新性的大胆尝试，在尽可能保留铜原来的颜色的同时进行一些艺术处理，
          配以电子智能科技，让传统与现代科技互相结合辉映
        </p>
      </div>
    </div>

    <div class="icons">
      <img src="@/assets/new.jpg" />
    </div>

    <div class="pre">
      <div class="carouselBorder">
        <el-carousel :interval="5000" arrow="always">
          <el-carousel-item v-for="(item, index) in dataList" :key="index">
            <img :src="item.imgPath" style="width: 100%;" />
            <br />
            <p>{{ item.title }}</p>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <div class="twoImg">
      <img src="@/assets/27.jpg" />
      <img src="@/assets/28.jpg" />
    </div>

    <div class="pre">
      <div class="recommend">新品推荐</div>
    </div>

    <test-one :dataList="catalogList" class="test-one" />

    <test-one-phone :dataList="catalogList" class="test-one-phone" />

    <my-footer />
  </div>
</template>

<script>
import myHeader from "@/views/myHeader.vue";
import myFooter from "@/views/myFooter.vue";
import testOne from "@/views/testOne.vue";
import testOnePhone from "@/views/testOnePhone.vue";

export default {
  components: {
    myHeader,
    myFooter,
    testOne,
    testOnePhone
  },
  data() {
    return {
      dataList: [],
      catalogList: [],
      imgUrl: [
        require("@/assets/carousel.jpg"),
        require("@/assets/carousel.jpg")
      ]
    };
  },
  mounted() {
    if (this.$route.query.go) {
      // debugger
      document.querySelector("#" + this.$route.query.go).scrollIntoView(true);
    }
    let that = this;
    that.$axios
      .get(that.$global.baseURL + "/web/newsList/getNewsListByCatalogId.form", {
        params: {
          catalogId: "3"
        }
      })
      .then(res => {
        if (res.data.jsonArray == "error") {
          uni.showModal({
            title: res.data.errorInfo,
            showCancel: false
          });
        } else {
          that.dataList = res.data.dataList;
        }
      });

    that.$axios
      .get(
        that.$global.baseURL + "/web/productList/getProductDataByType.form",
        {
          params: {
            type: "2"
          }
        }
      )
      .then(res => {
        if (res.data.jsonArray == "error") {
          uni.showModal({
            title: res.data.errorInfo,
            showCancel: false
          });
        } else {
          that.catalogList = res.data.dataList;
        }
      });
  }
};
</script>

<style>
.test >>> .imgBar {
  margin-bottom: 80px;
}

.footerNav >>> .footer1 {
  border-top: 1px solid #c4c4c4;
}

/*最外层 */
.newProduct .pre {
  width: 100%;
}

.newProduct .pre .allTitle {
  width: 90%;
  text-align: center;
  margin: 0 auto;
  color: #8d8c8c;
  font-size: 53px;
  padding: 40px 0;
  letter-spacing: 20px;
  font-weight: lighter;
  /* padding: 25px 0; */
}

.newProduct .allWord p {
  text-align: center;
  font-size: 16px;
  padding-top: 10px;
  color: #595757;
}

.newProduct .allWord .p1 {
  letter-spacing: 15px;
}

.newProduct .img1 img {
  width: 100%;
}

.newProduct .future {
  width: 100%;
  text-align: center;
  padding: 40px 0;
}

.newProduct .future img {
  width: 40%;
}

.newProduct .news {
  width: 85%;
  margin: 0 auto;
  text-align: center;
  color: #595757;
}

.newProduct .news .p1 {
  font-size: 25px;
  font-weight: lighter;
}

.newProduct .news .p2 {
  font-size: 14px;
  padding-top: 10px;
}

.newProduct .icons {
  /* width: 50%; */
  margin: 0 auto;
  text-align: center;
  margin-top: 30px;
}

.newProduct .icons img {
  width: 24%;
}

.newProduct .iconWord {
  width: 40%;
  margin: 0 auto;
  text-align: center;
}

.newProduct .iconWord span {
  font-size: 12px;
  margin-left: 22px;
}

.newProduct .pre .carouselBorder {
  margin-top: 100px;
  margin-bottom: 100px;
}

.newProduct .pre .carouselBorder .el-carousel__container {
  width: 100%;
  height: 700px;
}

.newProduct .pre .carouselBorder .el-carousel__arrow {
  top: 45%;
  font-size: 20px;
  color: white;
  border: 1px solid white;
}

.newProduct .pre .el-carousel__arrow--left {
  margin-left: 230px;
}

.newProduct .pre .el-carousel__arrow--right {
  margin-right: 230px;
}

.newProduct .pre .el-carousel__indicators--horizontal {
  display: none;
}

.newProduct .pre .carouselBorder p {
  width: 100%;
  font-size: 40px;
  text-align: center;
  margin-bottom: 120px;
  font-weight: lighter;
}

.newProduct .twoImg {
  width: 100%;
  margin-bottom: 50px;
}

.newProduct .twoImg img {
  width: 100%;
}

.newProduct .recommend {
  width: 85%;
  margin: 0 auto;
  line-height: 40px;
  border-bottom: 1px solid #c4c4c4;
  padding-bottom: 8px;
}

.newProduct .test-one {
  display: block;
}

.newProduct .test-one-phone {
  display: none;
}

/* 576px */

@media screen and (max-width: 850px) {
  .newProduct .icons img {
    width: 62%;
  }

  .newProduct .pre .carouselBorder {
    margin-top: 60px;
    margin-bottom: 60px;
    height: 200px;
  }

  .newProduct .pre .carouselBorder .el-carousel__container {
    height: 300px;
  }

  .newProduct .pre .carouselBorder .el-carousel__arrow {
    top: 10%;
  }

  .newProduct .pre .carouselBorder .el-carousel__arrow--left {
    margin-left: 40px;
  }

  .newProduct .pre .carouselBorder .el-carousel__arrow--right {
    margin-right: 40px;
  }

  .newProduct .pre .carouselBorder .el-carousel__indicators--horizontal {
    display: none;
  }

  .newProduct .pre .carouselBorder p {
    font-size: 30px;
    margin-bottom: 0;
  }

  .newProduct .test-one {
    display: none;
  }

  .newProduct .test-one-phone {
    display: block;
  }
}

@media screen and (max-width: 1300px) {
  .newProduct .pre .carouselBorder .el-carousel__container {
    height: 570px;
  }

  .newProduct .pre .carouselBorder .el-carousel__arrow {
    top: 45%;
  }
}

@media screen and (min-width: 1400px) {
  .newProduct .pre .carouselBorder .el-carousel__container {
    height: 850px;
  }
}
</style>
